/** Базовый путь панели (было /dashboard) */
export const APP_BASE = '/discordmoderation';

export const APP_HOME = `${APP_BASE}/overview`;

/** Календарь (было /dashboard/calls-schedule) */
export const APP_CALENDAR = `${APP_BASE}/calendar`;
